import { computed, ref, watch, nextTick, provide, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ecdc57ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 苹果商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID自动生成规则：包名+内购名称，全小写，不超过100字符", -1));
const _hoisted_9 = {
  key: 3,
  style: {
    "margin-left": "80px",
    "color": "rgba(0, 0, 0, 0.45)"
  }
};
const _hoisted_10 = {
  class: "card priceCard"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_13 = {
  class: "price-tab-label"
};
const _hoisted_14 = {
  class: "taxRateBox"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "taxRateTitle"
}, "新加坡 GST 调价", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rate-tips"
}, "开启后新加坡本地价格将自动上调9%，以规避新加坡地区GST税费。", -1));
const _hoisted_17 = [_hoisted_15, _hoisted_16];
const _hoisted_18 = {
  class: "third-party-payment-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-party-payment-tips"
}, " 该功能尚在选品测试阶段，请确认游戏已接入「第三方支付」功能，否则配置无效； ", -1));
const _hoisted_20 = {
  class: "card current-price"
};
const _hoisted_21 = {
  class: "title"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_23 = {
  key: 0,
  style: {
    "text-align": "right"
  }
};
const _hoisted_24 = {
  class: "price-list"
};
const _hoisted_25 = {
  key: 0,
  class: "l-title"
};
const _hoisted_26 = {
  class: "name"
};
const _hoisted_27 = {
  class: "price"
};
const _hoisted_28 = {
  class: "area"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订阅价格", -1));
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  key: 0,
  class: "desc"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "l-title"
}, "当前价格", -1));
const _hoisted_33 = {
  class: "name"
};
const _hoisted_34 = {
  class: "price"
};
const _hoisted_35 = {
  class: "area"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订阅价格", -1));
const _hoisted_37 = {
  key: 0,
  class: "desc"
};
const _hoisted_38 = {
  class: "card"
};
const _hoisted_39 = {
  class: "title"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_41 = {
  style: {
    "float": "right"
  }
};
const _hoisted_42 = {
  key: 0,
  class: "ticket_add"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "如需为订阅商品设置「新用户」促销价格，请添加优惠方案", -1));
const _hoisted_44 = {
  key: 1,
  class: "ticket_form"
};
const _hoisted_45 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_46 = {
  class: "selectBox"
};
import { Select, SelectOption } from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import useGetSelect from '@/hooks/useGetSelect';
import MultiComponents from './components/MultiComponents1.vue';
import PriceBlock2 from './components/PriceBlock2.vue';
import PriceBlock1 from './components/PriceBlock1.vue';
import TierDefaultPrice from './components/TierDefaultPrice.vue';
import TierLocalPriceTable from './components/TierLocalPriceTable.vue';
import TierTemplateSwitch from './components/TierTemplateSwitch.vue';
import UnusedTierConfirmModal from './components/UnusedTierConfirmModal.vue';
import PriceModeConfirmModal from './components/PriceModeConfirmModal.vue';
import ThirdPartyPricePanel from './components/ThirdPartyPricePanel.vue';
import { fetchTierTemplateMappings, getUnusedTiers, filterUsedTierPrices, buildTieredPricing } from './services/tieredPricing';
import { DEFAULT_THIRD_PARTY_CHANNEL, THIRD_PARTY_CHANNEL_OPTIONS, createThirdPartyDraft, hasThirdPartySupport, isProdTypeSupported, mergeThirdPartyChannelPrices, normalizeThirdPartyDraft, resolveThirdPartyChannel } from './services/thirdPartyChannel';
import { DEFAULT_MISSING_OFFICIAL_TIP, calcDiscountRate } from './services/thirdPartyPricing';
import dayjs from 'dayjs';
import DyzModal from './components/dyzModal.vue';
import SelectModal from './components/SelectModal.vue';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep, debounce } from 'lodash';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { getLadderPrice } from '@/api/goodsInfo';
import useDetailHooks from './hooks/useDetailHooks';
import useManualProdId from './hooks/useManualProdId';
import { getSubscriptionGroupList } from '@/api/goodsInfo';
import { queryPkgInfo, queryGoods, addGoods, updGoods, getLastLangInfo } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined, DeleteOutlined, RestOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import EditModal from './components/EditModal.vue';
import { useStore } from '@/store';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'goodsSettingDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const layoutStore = useStore();
    const submitBlockStyle = computed(() => ({
      left: (layoutStore.isCollapsed ? 74 : 180) + 'px'
    }));
    const originLoading = ref(false);
    const priceTrend = ref(false);
    const dataText = ref('请选择结束日期');
    const endDate = ref();
    const endDateOpen = ref(false);
    const filterOption = (input, option) => {
      return option.regionName.indexOf(input) >= 0;
    };
    // 适用范围弹窗
    const visible = ref(false);
    //
    const showCountryModal = () => {
      visible.value = true;
    };
    const saveCountry = value => {
      prodGracePlan.value.regionConfigList = value;
      prodGracePlan.value.productNativePrice = yhConturyPrice.value;
    };
    // 比较两个字符串数字，1.0 和 1.00 ，是否相等
    function compareStringNumbers(str1, str2) {
      // 将字符串转换为数字
      let num1 = parseFloat(str1);
      let num2 = parseFloat(str2);
      // 比较两个数字是否相等
      return num1 === num2;
    }
    const route = useRoute();
    const router = useRouter();
    const {
      countryToCoin,
      getCountryCoinOptions
    } = useGetSelect();
    const {
      prodTypeOptions,
      basePlanDurationType,
      verifyNumber,
      validateIosPid
    } = useDetailHooks();
    const disabled = ref(false); // 禁用改动
    const modalVisible = ref(false); // 弹窗显示隐藏
    const priceTabKey = ref('1');
    // 定价模式：single 单一默认价格 / tiered 多默认价格（按国家分层定价）
    const priceMode = ref('single');
    // 苹果仅消耗型(20)、非消耗型(10)支持分层定价
    const showTieredOption = computed(() => ['10', '20'].includes(settingForm.value.prodType));
    // 层级模板开关（仅多默认价格模式显示）
    const tierTemplateEnabled = ref(true);
    // 是否新建（非编辑/查看）——仅新建场景回填模板
    const isNewGoods = computed(() => !['edit', 'watch'].includes(queryParams.value.type || ''));
    // 废弃层级二次确认弹窗
    const unusedModalOpen = ref(false);
    const unusedTiers = ref([]);
    const tieredSaving = ref(false);
    // 文案走 title，label 让位给页签插槽（option 上的 label 会覆盖插槽）
    const priceTabOptions = [{
      title: '苹果官方价格',
      value: '1'
    }, {
      title: '三方支付',
      value: '2'
    }];
    // 三方支付：总开关 + 唯一生效渠道 + 每个渠道各一份价格草稿
    const thirdPartyEnabled = ref(false);
    const thirdPartyChannel = ref(DEFAULT_THIRD_PARTY_CHANNEL);
    const thirdPartyDrafts = ref({
      xsolla_pay: createThirdPartyDraft(),
      enjoy_pay: createThirdPartyDraft()
    });
    // 价格面板与校验只认当前渠道那份草稿
    const thirdPartyConfig = computed({
      get: () => thirdPartyDrafts.value[thirdPartyChannel.value],
      set: draft => {
        thirdPartyDrafts.value[thirdPartyChannel.value] = draft;
      }
    });
    const thirdPartyPanelRef = ref(null);
    // 商品类型决定三方支付页签与可选渠道：Xsolla 支持消耗型/非消耗型，EnjoyPay 仅消耗型
    const showThirdPartyTab = computed(() => hasThirdPartySupport(settingForm.value.prodType));
    const isChannelAvailable = payChnl => isProdTypeSupported(payChnl, settingForm.value.prodType);
    const thirdPartyChannelName = computed(() => {
      var _THIRD_PARTY_CHANNEL_;
      return ((_THIRD_PARTY_CHANNEL_ = THIRD_PARTY_CHANNEL_OPTIONS.find(item => item.value === thirdPartyChannel.value)) === null || _THIRD_PARTY_CHANNEL_ === void 0 ? void 0 : _THIRD_PARTY_CHANNEL_.label) || 'Xsolla';
    });
    // 区域限制提示两个渠道都展示，渠道名跟着当前选中渠道走
    const thirdPartyPriceTip = computed(() => `当前 iOS 产品仅支持美区用户使用 ${thirdPartyChannelName.value} 支付`);
    // 三方价格的官方基准：单一默认价格取默认价，多默认价格（分层）取 T1 层级价
    const thirdPartyOfficialPrice = computed(() => {
      var _buildTierPrices$find;
      if (priceMode.value !== 'tiered') return settingForm.value.defaultPriceTier || '';
      return ((_buildTierPrices$find = buildTierPrices().find(t => t.tierCode === 'T1')) === null || _buildTierPrices$find === void 0 ? void 0 : _buildTierPrices$find.prodPrice) || '';
    });
    const thirdPartyOfficialTip = computed(() => priceMode.value === 'tiered' ? '请先填写 T1 层级默认价' : DEFAULT_MISSING_OFFICIAL_TIP);
    const thirdPartyDiscountNum = computed(() => calcDiscountRate(thirdPartyOfficialPrice.value, thirdPartyConfig.value.prodPrice));
    // 官方价改动后刷新折扣描述（价格本身的改动由面板在失焦时处理）
    const calcPromotionDesc = debounce(() => {
      var _thirdPartyPanelRef$v;
      return (_thirdPartyPanelRef$v = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v === void 0 ? void 0 : _thirdPartyPanelRef$v.refreshPromotionDesc();
    }, 300);
    // 重置三方支付：新建 / 连续创建 / 切换商品类型时清空草稿
    const resetThirdParty = () => {
      var _thirdPartyPanelRef$v2;
      thirdPartyEnabled.value = false;
      thirdPartyChannel.value = DEFAULT_THIRD_PARTY_CHANNEL;
      thirdPartyDrafts.value = {
        xsolla_pay: createThirdPartyDraft(),
        enjoy_pay: createThirdPartyDraft()
      };
      (_thirdPartyPanelRef$v2 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v2 === void 0 || _thirdPartyPanelRef$v2.clearValidate();
    };
    // 切换渠道：展示目标渠道自己的价格；目标渠道没有存过也没填过时沿用当前输入，不清空
    watch(thirdPartyChannel, (next, prev) => {
      var _thirdPartyPanelRef$v3;
      if (prev && !thirdPartyDrafts.value[next].prodPrice) {
        thirdPartyDrafts.value[next] = {
          ...thirdPartyDrafts.value[prev]
        };
      }
      (_thirdPartyPanelRef$v3 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v3 === void 0 || _thirdPartyPanelRef$v3.clearValidate();
    });
    // 切回三方支付页签时按最新官方价重新校验（官方价可能在苹果页签被改过）；
    // 三方价格还没填时不触发校验，避免一进来就飘红
    watch(priceTabKey, key => {
      if (key !== '2') return;
      nextTick(() => {
        var _thirdPartyPanelRef$v5;
        if (!thirdPartyEnabled.value || !thirdPartyConfig.value.prodPrice) {
          var _thirdPartyPanelRef$v4;
          (_thirdPartyPanelRef$v4 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v4 === void 0 || _thirdPartyPanelRef$v4.clearValidate();
          return;
        }
        (_thirdPartyPanelRef$v5 = thirdPartyPanelRef.value) === null || _thirdPartyPanelRef$v5 === void 0 || _thirdPartyPanelRef$v5.validate();
      });
    });
    // 保存前校验：开启三方支付后渠道必须支持当前商品类型，且价格必须合法
    const checkThirdPartyChannel = () => {
      var _thirdPartyPanelRef$v6;
      if (!showThirdPartyTab.value || !thirdPartyEnabled.value) return true;
      if (!isChannelAvailable(thirdPartyChannel.value)) {
        priceTabKey.value = '2';
        message.error('请选择开启渠道');
        return false;
      }
      if (!((_thirdPartyPanelRef$v6 = thirdPartyPanelRef.value) !== null && _thirdPartyPanelRef$v6 !== void 0 && _thirdPartyPanelRef$v6.validate())) {
        priceTabKey.value = '2';
        message.error(`请填写合法的 ${thirdPartyChannelName.value} 默认价格`);
        return false;
      }
      return true;
    };
    // 组装下发用 channelPrices：原样保留接口返回的其他键，草稿只写入当前渠道
    const buildThirdPartyChannelPrices = () => {
      var _originObj$value;
      if (!showThirdPartyTab.value) return undefined;
      return mergeThirdPartyChannelPrices((_originObj$value = originObj.value) === null || _originObj$value === void 0 ? void 0 : _originObj$value.channelPrices, {
        enabled: thirdPartyEnabled.value,
        channel: thirdPartyChannel.value,
        draft: thirdPartyConfig.value,
        discount: thirdPartyDiscountNum.value != null ? `${thirdPartyDiscountNum.value}%` : ''
      });
    };
    provide('basePlanDurationType', basePlanDurationType);
    const timeStep = [{
      label: '一周',
      value: 'ONE_WEEK'
    }, {
      label: '一个月',
      value: 'ONE_MONTH'
    }, {
      label: '两个月',
      value: 'TWO_MONTHS'
    }, {
      label: '三个月',
      value: 'THREE_MONTHS'
    }, {
      label: '六个月',
      value: 'SIX_MONTHS'
    }, {
      label: '一年',
      value: 'ONE_YEAR'
    }];
    const textMap = {
      APPROVED: '已上架',
      DEVELOPER_ACTION_NEEDED: '待开发人员处理',
      DEVELOPER_REMOVED_FROM_SALE: '待开发者处理',
      IN_REVIEW: '待提交',
      MISSING_METADATA: '待提交元数据',
      PENDING_BINARY_APPROVAL: '待提交二进制',
      PROCESSING_CONTENT: '正在处理',
      READY_TO_SUBMIT: '准备提交',
      REJECTED: '被拒绝',
      REMOVED_FROM_SALE: '被下架',
      WAITING_FOR_REVIEW: '正在等待审核',
      WAITING_FOR_UPLOAD: '待上传'
    };
    const statusText = computed(() => {
      return textMap[settingForm.value.appleState] || settingForm.value.appleState;
    });
    // 优惠开始时间
    const disabledDate = current => {
      return current && current < dayjs().startOf('day');
    };
    // 优惠结束时间 要大于开始时间和当日
    const disabledDate1 = current => {
      return current && (current < dayjs(prodGracePlan.value.startDate).endOf('day') || current < dayjs().endOf('day'));
    };
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null,
      type: '' // 类型
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const multiComponentRef = ref(null); // 组件ref
    const priceBlockRef = ref(null);
    const tierDefaultRef = ref(null); // 多默认价格-层级默认价组件
    const tierLocalRef = ref(null); // 多默认价格-本地价格表组件
    // 有效层级（供本地价格表层级下拉）：仅已填基准价的层级（问题2，空层级不可选）；T1 始终在内
    const tierLevels = computed(() => {
      var _tierDefaultRef$value;
      const levels = (((_tierDefaultRef$value = tierDefaultRef.value) === null || _tierDefaultRef$value === void 0 ? void 0 : _tierDefaultRef$value.validTiers()) || []).map(t => t.tierCode);
      return levels.length ? levels : ['T1'];
    });
    const myFormRef = ref(null);
    const dzmodal = ref(); // 订阅组
    const lastLangInfo = ref([]);
    const spinning = ref(false); // 本地价格加载中
    const yhShow = ref(false); // 优惠方案显示隐藏
    const showLastLangInfo = ref(false); // 历史语言信息显示隐藏
    const yhShowChange = flag => {
      var _priceBlockRef$value;
      const arr1 = (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 ? void 0 : _priceBlockRef$value.showData.map(item => item.regionCode);
      arr1.push(defaultCountryId.value);
      prodGracePlan.value = {
        regionConfigList: arr1,
        type: 'FREE_TRIAL',
        duration: 'THREE_DAYS',
        productNativePrice: yhConturyPrice.value.map(item => ({
          ...item
        })),
        startDate: '',
        endDate: ''
      };
      yhShow.value = flag;
    }; // 优惠方案添加删除
    const prodGracePlan = ref({
      regionConfigList: [],
      type: 'FREE_TRIAL',
      duration: 'THREE_DAYS',
      productNativePrice: [],
      startDate: '',
      endDate: ''
    }); // 优惠设置
    const yhContury = computed(() => {
      var _priceBlockRef$value$;
      const arr = priceBlockRef.value ? (_priceBlockRef$value$ = priceBlockRef.value.showData) === null || _priceBlockRef$value$ === void 0 ? void 0 : _priceBlockRef$value$.filter(item => prodGracePlan.value.regionConfigList.includes(item.regionCode)) : [];
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      // arr.push()
      return arr || [];
    }); // 适用范围 是价格设置里的本地价格列表
    const taxRateSwitch = ref(true); // 新加坡税率开关
    const cCountry = ref('');
    // 查询到的所有地区值
    const allAreaList = computed(() => {
      var _priceBlockRef$value2;
      const arr = (_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 ? void 0 : _priceBlockRef$value2.showData.map(item => {
        return item.regionName;
      });
      return arr;
    });
    // 最初的价格历史合集
    const originPriceList = ref([]);
    const allData = computed(() => {
      var _priceBlockRef$value3;
      const arr = (_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.showData.map(item => item);
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      return arr;
    }); // 适用范围弹窗的数据
    const yhConturyPrice = computed(() => {
      var _priceBlockRef$value4;
      const arr = (_priceBlockRef$value4 = priceBlockRef.value) === null || _priceBlockRef$value4 === void 0 ? void 0 : _priceBlockRef$value4.showData.filter(item => prodGracePlan.value.regionConfigList.includes(item.regionCode));
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      return arr;
    }); // 本地价格 是适用范围的列表
    const saveLoading = ref(false); // 保存按钮可用性
    const defaultCountry = ref([]); // 默认价格国家
    const defaultCountryId = ref('USA'); // 默认价格国家ID
    const conturyPrice = ref([]); // 默认价格列表
    const conturyPriceLoading = ref(false); // 获取默认价格loading
    const futurePriceList = ref([]); // 即将生效价格列表
    const cPriceList = ref([{
      title: '',
      money: '',
      area: '',
      areaList: [],
      desc: ''
    }]);
    const isDeletedShow = ref(false);
    const isOriginHave = ref(true);
    const originObj = ref({});
    const dyList = ref([]); // 订阅列表
    const clickDzAdd = () => {
      modalVisible.value = true;
      dzmodal.value.openModal();
    }; // 打开订阅组弹窗
    // 计算默认价格国家
    const calcSelectOptions = async _ => {
      var _priceBlockRef$value5;
      // 重置默认价格层级为空白，准备加载新的价格信息
      settingForm.value.defaultPriceTier = '';
      // 初始化国家价格列表为空数组
      conturyPrice.value = [];
      // 重置价格块的表单状态，清除之前的价格数据
      (_priceBlockRef$value5 = priceBlockRef.value) === null || _priceBlockRef$value5 === void 0 || _priceBlockRef$value5.reset();
      // 重置产品优惠计划的区域配置列表为空数组
      prodGracePlan.value.regionConfigList = [];
      // 开始加载国家价格数据，设置加载状态为true
      conturyPriceLoading.value = true;
      // 异步获取梯度价格信息，根据当前选定的DBT ID、区域代码和产品类型
      const res = await getLadderPrice({
        dbtId: queryParams.value.dbtId,
        regionCode: defaultCountryId.value,
        prodType: settingForm.value.prodType
      });
      // 结束加载状态，设置为false
      conturyPriceLoading.value = false;
      // 根据接口返回码处理返回的数据，若成功则更新国家价格列表，否则清空列表
      if (res.code === '0') {
        conturyPrice.value = res.data;
      } else {
        conturyPrice.value = [];
      }
    };
    // 变更默认价格需要重新请求价目表
    const changeProdPrice = async (_, isDetail = false) => {
      var _priceBlockRef$value6;
      settingForm.value.defaultPriceTier = _;
      if (!settingForm.value.defaultPriceTier) {
        message.warning('请先填写默认价格');
        return;
      }
      const item = conturyPrice.value.find(item => compareStringNumbers(item.prodPrice, settingForm.value.defaultPriceTier));
      if (item && item.prodPrice && parseFloat(item.prodPrice) <= 0) {
        settingForm.value.prodPrice = '';
        return;
      } else {
        settingForm.value.prodPrice = item.prodPrice;
      }
      const flag = await verifyNumber({
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodPriceCurrency: settingForm.value.prodPriceCurrency,
        prodType: settingForm.value.prodType
      });
      if (!flag) {
        settingForm.value.prodPrice = '';
        return;
      }
      let params = {
        pkg: settingForm.value.pkg,
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodType: settingForm.value.prodType,
        dbtId: queryParams.value.dbtId,
        prodPriceCurrency: item.prodPriceCurrency,
        regionCode: defaultCountryId.value
      };
      // if (isShowTicket.value) {
      params.priceId = item.priceId;
      // } else {
      params.priceTier = item.priceTier;
      // }
      // 增加开关控制参数
      if (showRateSwitch.value) {
        params = Object.assign({}, params, {
          applySgtAdjustment: taxRateSwitch.value
        });
      }
      (_priceBlockRef$value6 = priceBlockRef.value) === null || _priceBlockRef$value6 === void 0 || _priceBlockRef$value6.reset();
      prodGracePlan.value.regionConfigList = [];
      try {
        spinning.value = true;
        if (isDetail !== true) {
          var _priceBlockRef$value7;
          await ((_priceBlockRef$value7 = priceBlockRef.value) === null || _priceBlockRef$value7 === void 0 ? void 0 : _priceBlockRef$value7.queryData(params)); // 价格列表初始化
        }
      } finally {
        spinning.value = false;
      }
      calcPromotionDesc();
    };
    // 处理下拉框change事件，不直接修改下拉值
    const handlePriceTierChange = async () => {
      await changeProdPrice(settingForm.value.defaultPriceTier);
    };
    // GST 调价：单一模式重算价格块；分层模式作为 applySgtAdjustment 入参交后端①重算
    const onGstChange = () => {
      if (priceMode.value === 'tiered') {
        regenerateTiered();
      } else {
        handlePriceTierChange();
      }
    };
    const onGstClick = () => {
      if (rateSwitchStatus.value || conturyPriceLoading.value) return;
      taxRateSwitch.value = !taxRateSwitch.value;
      onGstChange();
    };
    // 苹果层级基准价 → 接口①/保存用 tierPrices（国家档位价：带 regionCode/priceTier/priceId）
    const buildTierPrices = () => {
      var _tierDefaultRef$value2;
      return (((_tierDefaultRef$value2 = tierDefaultRef.value) === null || _tierDefaultRef$value2 === void 0 ? void 0 : _tierDefaultRef$value2.validTiers()) || []).map(t => ({
        tierCode: t.tierCode,
        prodPrice: t.prodPrice,
        prodPriceCurrency: t.prodPriceCurrency,
        regionCode: t.regionCode || '',
        priceId: t.priceId || '',
        priceTier: t.priceTier || ''
      }));
    };
    // 是否已为本次新建回填过层级模板（避免重复回填/死循环）
    const tierTemplateApplied = ref(false);
    // 切到分层模式时拉到的国家-层级模板，待本地价表生成后回填一次
    const pendingTemplateMappings = ref(null);
    // 编辑态首次回显中：抑制接口①（本地价直接取 productNativePrice）；回显完成后照常重算
    const tieredRestoring = ref(false);
    // 调接口①生成本地价。新建场景：先把模板映射记进组件（按有效层级/手动覆盖在 generate 时渐进生效），
    // 待首次拿到国家全集后再生成一次，让模板对应层级的国家按其层级算价。
    const runGenerateTiered = async () => {
      var _pendingTemplateMappi, _tierLocalRef$value2, _pendingTemplateMappi2, _tierLocalRef$value3;
      const gst = showRateSwitch.value ? taxRateSwitch.value : undefined;
      if (isNewGoods.value && !tierTemplateApplied.value && (((_pendingTemplateMappi = pendingTemplateMappings.value) === null || _pendingTemplateMappi === void 0 ? void 0 : _pendingTemplateMappi.length) || 0) > 0) {
        var _tierLocalRef$value;
        (_tierLocalRef$value = tierLocalRef.value) === null || _tierLocalRef$value === void 0 || _tierLocalRef$value.applyTemplateMappings(pendingTemplateMappings.value);
      }
      await ((_tierLocalRef$value2 = tierLocalRef.value) === null || _tierLocalRef$value2 === void 0 ? void 0 : _tierLocalRef$value2.generate(buildTierPrices(), gst));
      if (isNewGoods.value && !tierTemplateApplied.value && (((_pendingTemplateMappi2 = pendingTemplateMappings.value) === null || _pendingTemplateMappi2 === void 0 ? void 0 : _pendingTemplateMappi2.length) || 0) > 0 && (((_tierLocalRef$value3 = tierLocalRef.value) === null || _tierLocalRef$value3 === void 0 || (_tierLocalRef$value3 = _tierLocalRef$value3.list) === null || _tierLocalRef$value3 === void 0 ? void 0 : _tierLocalRef$value3.length) || 0) > 0) {
        var _tierLocalRef$value4;
        tierTemplateApplied.value = true;
        await ((_tierLocalRef$value4 = tierLocalRef.value) === null || _tierLocalRef$value4 === void 0 ? void 0 : _tierLocalRef$value4.generate(buildTierPrices(), gst));
      }
    };
    // 防抖：层级默认价/国家映射/GST 变化 → 重新调接口①生成全表
    // 编辑态首次回显期间跳过，避免覆盖 productNativePrice 回显的本地价
    let tierGenTimer = null;
    const regenerateTiered = () => {
      if (tieredRestoring.value) return;
      if (tierGenTimer) clearTimeout(tierGenTimer);
      tierGenTimer = setTimeout(runGenerateTiered, 800);
    };
    // 层级默认价改动（改价/填价/清空价/删层级，均由 TierDefaultPrice emit 携带层级码）→ 是否重算本地价（接口①）：
    // T1 全局兜底层级（或苹果选基准国价无层级码）改动必重算；
    // 其余层级仅当该层级有国家归属（当前/模板/手动）时才重算，无国家的层级变动不影响接口输出，跳过
    const onTierDefaultPriceChange = tierCode => {
      var _tierLocalRef$value5;
      if (!tierCode || tierCode === 'T1') {
        regenerateTiered();
        return;
      }
      if ((_tierLocalRef$value5 = tierLocalRef.value) !== null && _tierLocalRef$value5 !== void 0 && _tierLocalRef$value5.hasCountriesInTier(tierCode)) {
        regenerateTiered();
      }
    };
    // 用户切到分层模式：立即拉取国家-层级模板（新建场景），再触发一次生成（回显走 getDetail，不经此处）
    const onPriceModeChange = async e => {
      var _e$target;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) === 'tiered') {
        var _tierLocalRef$value6;
        // 已有分层数据（编辑回显或之前已配置）→ 切回时保留，不重新生成覆盖已填/已改的本地价
        if ((((_tierLocalRef$value6 = tierLocalRef.value) === null || _tierLocalRef$value6 === void 0 || (_tierLocalRef$value6 = _tierLocalRef$value6.list) === null || _tierLocalRef$value6 === void 0 ? void 0 : _tierLocalRef$value6.length) || 0) > 0) return;
        tierTemplateApplied.value = false;
        pendingTemplateMappings.value = null;
        if (isNewGoods.value) {
          pendingTemplateMappings.value = await fetchTierTemplateMappings({
            dbtId: queryParams.value.dbtId,
            prodChnl: queryParams.value.prodChnl,
            prodType: settingForm.value.prodType
          });
        }
        nextTick(runGenerateTiered);
      }
    };
    // 分层定价商品信息校验（名称/描述；价格取本地价格表）
    const checkerTiered = () => {
      var _tierLocalRef$value7;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        const item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
      }
      const rows = ((_tierLocalRef$value7 = tierLocalRef.value) === null || _tierLocalRef$value7 === void 0 ? void 0 : _tierLocalRef$value7.list) || [];
      if (!rows.length) {
        message.error('请先填写层级默认价生成本地价格');
        return false;
      }
      for (let i = 0; i < rows.length; i++) {
        if (!rows[i].prodPrice) {
          message.error('价格信息内容请填写完整');
          return false;
        }
      }
      return true;
    };
    // 分层定价保存：基础校验 → 层级默认价校验 → 检出空置层级 → 弹窗确认 / 直接提交
    const handleTieredSave = async () => {
      var _tierDefaultRef$value3, _tierDefaultRef$value4, _tierLocalRef$value8;
      try {
        await myFormRef.value.validate();
      } catch {
        return;
      }
      if (!checkerTiered()) return;
      if (!checkThirdPartyChannel()) return;
      if (!((_tierDefaultRef$value3 = tierDefaultRef.value) !== null && _tierDefaultRef$value3 !== void 0 && _tierDefaultRef$value3.validate())) {
        message.error('请完整填写层级默认价（T1 必填）');
        return;
      }
      // 两种定价模式都有完整价格时才提示当前保存模式；确认后继续空置层级校验/提交
      if (shouldConfirmPriceMode() && !modeConfirmed.value) {
        priceModeConfirmOpen.value = true;
        return;
      }
      modeConfirmed.value = false;
      const validCodes = (((_tierDefaultRef$value4 = tierDefaultRef.value) === null || _tierDefaultRef$value4 === void 0 ? void 0 : _tierDefaultRef$value4.validTiers()) || []).map(t => t.tierCode);
      const mappings = ((_tierLocalRef$value8 = tierLocalRef.value) === null || _tierLocalRef$value8 === void 0 ? void 0 : _tierLocalRef$value8.getCountryTierMappings()) || [];
      const unused = getUnusedTiers(validCodes, mappings);
      if (unused.length) {
        unusedTiers.value = unused;
        unusedModalOpen.value = true;
        return;
      }
      await submitTiered();
    };
    // 组装并提交分层定价商品（并入 addGoods/updGoods，bizInfo.tieredPricing 承载层级配置）
    const submitTiered = async (excludeTierCodes = []) => {
      tieredSaving.value = true;
      try {
        var _tierLocalRef$value9, _tierLocalRef$value10;
        // 保存的国家映射含 T1 国家（后端需显式落库）；接口①/空置层级校验仍用不含 T1 的 getCountryTierMappings
        const countryTierMappings = ((_tierLocalRef$value9 = tierLocalRef.value) === null || _tierLocalRef$value9 === void 0 ? void 0 : _tierLocalRef$value9.getCountryTierMappingsForSave()) || [];
        // tierPrices 由 countryTierMappings 反推：没有任何国家归属的层级（如设了 T3 价但无 T3 国家）不下发，
        // 与接口① generate 同口径；excludeTierCodes 来自空置层级弹窗的二次确认。
        const tierPrices = filterUsedTierPrices(buildTierPrices(), countryTierMappings).filter(tp => !excludeTierCodes.includes(tp.tierCode));
        // 顶层默认价/档位字段按 T1 层级铺设，与单一价格流入参口径一致（其余必填值取 T1）
        const t1 = tierPrices.find(t => t.tierCode === 'T1');
        const params = {
          ...settingForm.value,
          prodChnl: queryParams.value.prodChnl,
          dbtId: queryParams.value.dbtId,
          regionCode: (t1 === null || t1 === void 0 ? void 0 : t1.regionCode) || '',
          prodPrice: (t1 === null || t1 === void 0 ? void 0 : t1.prodPrice) || '',
          prodPriceCurrency: (t1 === null || t1 === void 0 ? void 0 : t1.prodPriceCurrency) || settingForm.value.prodPriceCurrency,
          defaultPriceTier: (t1 === null || t1 === void 0 ? void 0 : t1.priceTier) || '',
          defaultPriceId: (t1 === null || t1 === void 0 ? void 0 : t1.priceId) || '',
          productNativePrice: ((_tierLocalRef$value10 = tierLocalRef.value) === null || _tierLocalRef$value10 === void 0 ? void 0 : _tierLocalRef$value10.getNativePrices()) || []
        };
        // 分层仅消耗型(20)/非消耗型(10)，无订阅组
        delete params.prodBasePlan;
        params.bizInfo = {
          ...(settingForm.value.bizInfo || {}),
          tieredPricing: buildTieredPricing({
            tierPrices,
            countryTierMappings,
            saveAsTemplate: tierTemplateEnabled.value
          }),
          sgtPriceAdjustment: {
            enabled: showRateSwitch.value ? taxRateSwitch.value : false
          }
        };
        // 分层保存同样要下发三方渠道互斥开关，否则分层商品的三方配置会在保存时丢失
        const channelPrices = buildThirdPartyChannelPrices();
        if (channelPrices) params.channelPrices = channelPrices;
        const fn = queryParams.value.id ? updGoods : addGoods;
        const res = await fn(params);
        if (res.code === '0') {
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: 'ios商品配置',
              element_name: '保存'
            }
          });
          message.success('商品保存成功！');
          if (!saveNext.value) {
            router.push({
              name: 'goodsSetting'
            });
          } else {
            var _priceBlockRef$value8, _tierDefaultRef$value5, _tierLocalRef$value11;
            // 连续创建：留在本页清空配置，保留分层定价模式，重置层级默认价与本地价格表
            priceTabKey.value = '1';
            resetThirdParty();
            settingForm.value.productNativeInfo = params.productNativeInfo.map(item => ({
              ...item,
              prodName: '',
              prodDescription: ''
            }));
            resetManualProdId();
            settingForm.value.prodId = settingForm.value.pkg;
            settingForm.value.prodPrice = '';
            settingForm.value.prodType = '';
            settingForm.value.remark = '';
            conturyPrice.value = [];
            defaultCountryId.value = '';
            settingForm.value.defaultPriceTier = '';
            (_priceBlockRef$value8 = priceBlockRef.value) === null || _priceBlockRef$value8 === void 0 || _priceBlockRef$value8.reset();
            // 分层专属：重置层级默认价 + 本地价格表（含手动/模板映射），避免上一个商品配置残留
            (_tierDefaultRef$value5 = tierDefaultRef.value) === null || _tierDefaultRef$value5 === void 0 || _tierDefaultRef$value5.reset();
            (_tierLocalRef$value11 = tierLocalRef.value) === null || _tierLocalRef$value11 === void 0 || _tierLocalRef$value11.reset();
            tierTemplateEnabled.value = true;
            tierTemplateApplied.value = false;
            pendingTemplateMappings.value = null;
          }
        } else {}
      } catch (error) {} finally {
        tieredSaving.value = false;
        unusedModalOpen.value = false;
      }
    };
    // 弹窗【确认并保存】：移除空置层级后提交
    const onUnusedConfirm = () => {
      submitTiered(unusedTiers.value);
    };
    // 弹窗【取消并去分配】：关闭回页面，不保存
    const onUnusedCancel = () => {
      unusedModalOpen.value = false;
    };
    // 分层定价回显：读取 bizInfo.tieredPricing，铺层级默认价与本地价格表（不重新调接口①）
    const restoreTiered = data => {
      var _data$bizInfo;
      const tp = data === null || data === void 0 || (_data$bizInfo = data.bizInfo) === null || _data$bizInfo === void 0 ? void 0 : _data$bizInfo.tieredPricing;
      if (!tp || tp.pricingMode !== 'MULTI_DEFAULT_PRICE') return;
      priceMode.value = 'tiered';
      tierTemplateEnabled.value = !!tp.saveAsTemplate;
      tierTemplateApplied.value = true; // 回显不再自动拉模板
      tieredRestoring.value = true; // 首次回显：抑制接口①，本地价取 productNativePrice
      nextTick(async () => {
        var _tierDefaultRef$value6, _tierLocalRef$value12, _tierDefaultRef$value7;
        (_tierDefaultRef$value6 = tierDefaultRef.value) === null || _tierDefaultRef$value6 === void 0 || _tierDefaultRef$value6.init((tp.tierPrices || []).map(t => ({
          tierCode: t.tierCode,
          regionCode: t.regionCode,
          prodPriceCurrency: t.prodPriceCurrency,
          prodPrice: t.prodPrice,
          priceTier: t.priceTier,
          priceId: t.priceId
        })));
        (_tierLocalRef$value12 = tierLocalRef.value) === null || _tierLocalRef$value12 === void 0 || _tierLocalRef$value12.initFromSaved(data.productNativePrice || [], tp.countryTierMappings || []);
        // 把各层级基准国的价格下拉都查一次并展示
        await ((_tierDefaultRef$value7 = tierDefaultRef.value) === null || _tierDefaultRef$value7 === void 0 ? void 0 : _tierDefaultRef$value7.loadAllLadderOptions());
        // 回显（含 tierLevels 变化引发的 watch）落定后解除抑制，后续修改照常重算接口①
        nextTick(() => {
          tieredRestoring.value = false;
        });
      });
    };
    const isShowTicket = computed(() => {
      let flag1 = settingForm.value.prodType === '32'; // 是否是自动续期订阅
      return flag1;
    });
    const changeProdType = () => {
      var _priceBlockRef$value9, _tierDefaultRef$value8, _tierLocalRef$value13;
      priceTabKey.value = '1';
      priceMode.value = 'single';
      conturyPrice.value = [];
      defaultCountryId.value = '';
      settingForm.value.defaultPriceTier = '';
      (_priceBlockRef$value9 = priceBlockRef.value) === null || _priceBlockRef$value9 === void 0 || _priceBlockRef$value9.reset();
      // 分层组件改用 v-show 常驻后切类型不再卸载，需主动重置，避免上一个类型的层级默认价/本地价残留
      (_tierDefaultRef$value8 = tierDefaultRef.value) === null || _tierDefaultRef$value8 === void 0 || _tierDefaultRef$value8.reset();
      (_tierLocalRef$value13 = tierLocalRef.value) === null || _tierLocalRef$value13 === void 0 || _tierLocalRef$value13.reset();
      tierTemplateEnabled.value = true;
      tierTemplateApplied.value = false;
      pendingTemplateMappings.value = null;
      defaultCountryId.value = 'USA';
      calcSelectOptions();
    }; // 商品类型变更 默认价格重置
    const settingForm = ref({
      prodType: '',
      pkg: '',
      prodId: '',
      remark: '',
      productNativeInfo: [{
        key: 1,
        lang: 'en-US',
        langOptions: [],
        prodDescription: '',
        prodName: '',
        error: ''
      }],
      prodPrice: '',
      prodPriceCurrency: 'USD',
      prodBasePlan: {
        // 订阅组
        id: '',
        subscriptionType: '1',
        subscriptionPeriod: ''
      },
      defaultPriceTier: '',
      appleState: '' // 商品状态
    });
    const {
      isManualProdId,
      handleProdIdFocus,
      handleProdIdBlur,
      resetManualProdId
    } = useManualProdId(() => settingForm.value.prodId);
    // 商品类型变化后当前渠道可能不再支持（非消耗型没有 EnjoyPay），回落到默认渠道。
    // 必须放在 settingForm 声明之后：watch 的取值函数会立即执行一次
    watch(() => settingForm.value.prodType, prodType => {
      if (!isProdTypeSupported(thirdPartyChannel.value, prodType)) {
        thirdPartyChannel.value = DEFAULT_THIRD_PARTY_CHANNEL;
      }
    });
    const getPkg = async () => {
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.prodPriceCurrency = countryToCoin.value[res.data.country];
        cCountry.value = res.data.country;
        defaultCountry.value = res.data.defaultCountryOptions.map(item => {
          return {
            regionCode: item.regionCode,
            regionName: item.regionName + '(' + item.chnlCurrency + ')',
            prodPriceCurrency: item.prodPriceCurrency
          };
        });
      }
    }; //查询包名等信息
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const setProdId = e => {
      var _e;
      e = e.trim();
      if (queryParams.value.id || !((_e = e) !== null && _e !== void 0 && _e.length)) return; // 编辑时不允许修改内购ID
      if (isManualProdId.value) return; // 用户主动修改过，后面就不自动根据商品信息拼接
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9\.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        let countStr = 140 - settingForm.value.pkg.length - 1;
        settingForm.value.prodId = settingForm.value.pkg + '.' + getStr.slice(0, countStr);
      } catch (error) {}
      // myFormRef.value.validate()
    }; // 内购ID拼接
    const checker = () => {
      var _priceBlockRef$value10;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        var _item$prodName, _item$prodDescription, _item$prodName2, _item$prodDescription2;
        let item = settingForm.value.productNativeInfo[i];
        if (item.prodName.length < 2) {
          message.error('商品名称长度不能小于2');
          return false;
        }
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > 30) {
          item.error = '商品名称不能超过30个字符';
        }
        if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > 45) {
          item.error = '商品描述不能超过45个字符';
        }
        if (((_item$prodName2 = item.prodName) === null || _item$prodName2 === void 0 ? void 0 : _item$prodName2.length) <= 30 && ((_item$prodDescription2 = item.prodDescription) === null || _item$prodDescription2 === void 0 ? void 0 : _item$prodDescription2.length) <= 45) {
          item.error = '';
        }
      } // 商品信息校验
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      let getPriceArr = (_priceBlockRef$value10 = priceBlockRef.value) === null || _priceBlockRef$value10 === void 0 ? void 0 : _priceBlockRef$value10.originData;
      if (!getPriceArr.length) {
        message.error('价格信息表内容不能为空');
        return false;
      } else {
        for (let i = 0; i < getPriceArr.length; i++) {
          let item = getPriceArr[i];
          if (!item.prodPrice) {
            message.error('价格信息内容请填写完整');
            return false;
          }
        } // 价格信息校验
      }
      return true;
    }; // 自定义部分校验
    const refreshDy = () => {
      getPicker();
    }; // 刷新订阅组列表
    const getPicker = async () => {
      const res = await getSubscriptionGroupList({
        dbtId: queryParams.value.dbtId
      });
      dyList.value = [];
      if (res.code === '0') {
        dyList.value = res.data;
      }
    };
    // 处理保存字段
    const buildParams = () => {
      var _priceBlockRef$value11, _params$bizInfo;
      const item = conturyPrice.value.find(item => compareStringNumbers(item.prodPrice, settingForm.value.defaultPriceTier));
      let params = {
        ...settingForm.value,
        regionCode: item.regionCode,
        prodPriceCurrency: item.prodPriceCurrency,
        prodChnl: queryParams.value.prodChnl,
        dbtId: queryParams.value.dbtId,
        productNativePrice: (_priceBlockRef$value11 = priceBlockRef.value) === null || _priceBlockRef$value11 === void 0 ? void 0 : _priceBlockRef$value11.originData,
        defaultPriceTier: item.priceTier,
        defaultPriceId: item.priceId
      };
      switch (settingForm.value.prodType) {
        case '20':
        case '10':
          delete params.prodBasePlan;
          break;
        case '31':
          params.prodBasePlan = {
            id: '',
            subscriptionType: 0
          };
          break;
        case '32':
          params.prodBasePlan = {
            id: settingForm.value.prodBasePlan.id,
            subscriptionType: 1,
            subscriptionPeriod: settingForm.value.prodBasePlan.subscriptionPeriod
          };
          params.prodGracePlan = yhShow.value ? {
            ...prodGracePlan.value,
            startDate: dayjs(prodGracePlan.value.startDate).format('YYYY-MM-DD'),
            endDate: prodGracePlan.value.endDate ? dayjs(prodGracePlan.value.endDate).format('YYYY-MM-DD') : '',
            regionConfigList: yhConturyPrice.value.map(item => ({
              regionCode: item.regionCode
            })),
            productNativePrice: yhConturyPrice.value.map(k => ({
              ...k,
              discountType: 'FREE_TRIAL'
            }))
          } : null;
          break;
      }
      const isEditing = !!queryParams.value.id;
      let marketProdInfoModified = false;
      if (isEditing) {
        var _priceBlockRef$value$2, _priceBlockRef$value12;
        // 编辑时要判断苹果官方价格的备注、商品信息、价格设置有没有改变，有的话需要设置marketProdInfoModified为true
        const origin = originObj.value;
        const currentPriceList = (_priceBlockRef$value$2 = (_priceBlockRef$value12 = priceBlockRef.value) === null || _priceBlockRef$value12 === void 0 ? void 0 : _priceBlockRef$value12.originData) !== null && _priceBlockRef$value$2 !== void 0 ? _priceBlockRef$value$2 : [];
        const pickNameFields = list => list.map(({
          lang,
          prodDescription,
          prodName
        }) => ({
          lang,
          prodDescription,
          prodName
        }));
        const nameChanged = JSON.stringify(pickNameFields(settingForm.value.productNativeInfo)) !== JSON.stringify(pickNameFields(origin.productNativeInfo));
        const defaultPriceChanged = !compareStringNumbers(settingForm.value.defaultPriceTier, origin.prodPrice);
        const priceListChanged = (() => {
          const currentKeys = currentPriceList.map(i => `${i.regionCode}:${i.prodPrice}`).sort().join(',');
          const originKeys = origin.productNativePrice.map(i => `${i.regionCode}:${i.prodPrice}`).sort().join(',');
          return currentKeys !== originKeys;
        })();
        const remarkChanged = settingForm.value.remark !== origin.remark;
        marketProdInfoModified = nameChanged || defaultPriceChanged || priceListChanged || remarkChanged;
      }
      // 单一价格保存：按单一价格的数据结构提交，剔除可能残留的多默认价配置
      // （编辑态从多默认价切回单一时，settingForm.bizInfo 仍带着回显的 tieredPricing）
      if ((_params$bizInfo = params.bizInfo) !== null && _params$bizInfo !== void 0 && _params$bizInfo.tieredPricing) {
        delete params.bizInfo.tieredPricing;
      }
      const channelPrices = buildThirdPartyChannelPrices();
      if (channelPrices) {
        params.channelPrices = {
          ...channelPrices,
          extInfo: {
            ...(channelPrices.extInfo || {}),
            marketProdInfoModified
          }
        };
      }
      return params;
    };
    // 保存商品信息
    // 保存二次确认：先弹定价模式确认，确认后再执行实际保存
    const priceModeConfirmOpen = ref(false);
    const hasPriceRows = (prices = []) => prices.length > 0;
    // 只有单一价格与多默认价格都填全时才需要确认——此时两套数据都在，用户要知道保存后哪套生效
    const shouldConfirmPriceMode = () => {
      var _priceBlockRef$value13, _tierDefaultRef$value9, _tierLocalRef$value14;
      const hasSinglePrice = !!settingForm.value.prodPrice && hasPriceRows((_priceBlockRef$value13 = priceBlockRef.value) === null || _priceBlockRef$value13 === void 0 ? void 0 : _priceBlockRef$value13.originData);
      const hasTieredPrice = !!((_tierDefaultRef$value9 = tierDefaultRef.value) !== null && _tierDefaultRef$value9 !== void 0 && _tierDefaultRef$value9.validate()) && hasPriceRows((_tierLocalRef$value14 = tierLocalRef.value) === null || _tierLocalRef$value14 === void 0 ? void 0 : _tierLocalRef$value14.list);
      return hasSinglePrice && hasTieredPrice;
    };
    // 定价模式二次确认：复用 doSave/handleTieredSave 里已有的校验，不再单独抄一遍——
    // save 直接走 doSave，校验通过、真正提交前才弹此框；确认后置 modeConfirmed 再走一次 doSave 直接提交。
    const modeConfirmed = ref(false);
    const save = () => {
      modeConfirmed.value = false;
      doSave();
    };
    const onPriceModeConfirm = () => {
      priceModeConfirmOpen.value = false;
      modeConfirmed.value = true;
      doSave();
    };
    const onPriceModeConfirmCancel = () => {
      priceModeConfirmOpen.value = false;
    };
    const doSave = async () => {
      try {
        // 多默认价格（分层定价）保存流程
        if (showTieredOption.value && priceMode.value === 'tiered') {
          await handleTieredSave();
          return;
        }
        // 校验苹果官方价格默认价格（仅当前在 enjoypay tab 且未填时提示）
        if (priceTabKey.value === '2' && !settingForm.value.defaultPriceTier) {
          priceTabKey.value = '1';
        }
        const valid = await myFormRef.value.validate();
        if (!valid || !checker()) return;
        if (!checkThirdPartyChannel()) return;
        // 检查开始时间和结束时间
        //结束时间不能小于开始时间
        //开始时间不能小于当日
        if (yhShow.value && !prodGracePlan.value.startDate) {
          message.error('请选择开始时间');
          return;
        }
        if (prodGracePlan.value.startDate && prodGracePlan.value.endDate) {
          if (dayjs(prodGracePlan.value.startDate).isAfter(dayjs(prodGracePlan.value.endDate))) {
            message.error('结束时间不能小于开始时间');
            return;
          }
          if (dayjs(prodGracePlan.value.startDate).isBefore(dayjs().startOf('day'))) {
            message.error('开始时间不能小于当日');
            return;
          }
        }
        // 两种定价模式都有完整价格时才提示当前保存模式；确认后再走到这里直接提交
        if (shouldConfirmPriceMode() && !modeConfirmed.value) {
          priceModeConfirmOpen.value = true;
          return;
        }
        modeConfirmed.value = false;
        let params = buildParams();
        if (settingForm.value.prodType == '32' && queryParams.value.type == 'edit' && futurePriceList.value.length > 0
        // &&
        // settingForm.value.appleState == 'APPROVED'
        ) {
          const {
            regionCode,
            prodPrice,
            prodPriceCurrency,
            defaultPriceId,
            nextProductNativePrice,
            preserveCurrentPrice
          } = nextPriceData.value;
          originPriceList.value.forEach(item => {
            var _item$preserveCurrent, _item$startDate;
            // 1. 兼容性处理：保留原值或设为 null
            item.preserveCurrentPrice = (_item$preserveCurrent = item.preserveCurrentPrice) !== null && _item$preserveCurrent !== void 0 ? _item$preserveCurrent : null;
            item.startDate = (_item$startDate = item.startDate) !== null && _item$startDate !== void 0 ? _item$startDate : null;
            // 2. 查找匹配项
            const matched = nextProductNativePrice.find(ls => ls.regionName === item.regionName);
            // 3. 安全判断是否涨价（先确保 matched 存在）
            let isIncrease = false;
            if (matched) {
              const newPrice = Number(matched.prodPrice);
              const oldPrice = Number(item.prodPrice);
              // 确保价格是有效数字
              if (!isNaN(newPrice) && !isNaN(oldPrice)) {
                isIncrease = newPrice > oldPrice;
              }
            }
            // 4. 只有找到匹配项时才合并数据
            if (matched) {
              // 保留 item 原有的非覆盖字段，合并 matched，再覆盖 preserveCurrentPrice
              Object.assign(item, matched, {
                preserveCurrentPrice: isIncrease ? preserveCurrentPrice : null
                // 注意：startDate 等字段如果 matched 中没有，会被覆盖为 undefined！
              });
            }
            // 5. 删除不需要的属性
            delete item.price;
            delete item.key;
          });
          let upcomingPrices = {
            isDeleted: false,
            // preserveCurrentPrice, // 是否保持当前价格，当修改价格没有涨价时，此处为null
            regionCode,
            prodPrice,
            prodPriceCurrency,
            defaultPriceId: defaultPriceId || params.defaultPriceId,
            nextProductNativePrice: originPriceList.value
          };
          params.bizInfo.upcomingPrices = upcomingPrices;
        } else if (futurePriceList.value.length == 0 && params.bizInfo) {
          params.bizInfo.upcomingPrices = null;
        }
        if (isOriginHave && futurePriceList.value.length == 0 && params.bizInfo && originObj.value.bizInfo && originObj.value.bizInfo.upcomingPrices) {
          params.bizInfo.upcomingPrices = {
            ...originObj.value.bizInfo.upcomingPrices,
            isDeleted: true
          };
        }
        saveLoading.value = true;
        const fn = queryParams.value.id ? updGoods : addGoods;
        // 渠道ios+默认国家是sg则增加参数
        if (showRateSwitch.value) {
          params.bizInfo = {
            ...params.bizInfo,
            sgtPriceAdjustment: {
              enabled: taxRateSwitch.value
            }
          };
        } else {
          // 非调价区域增加参数处理
          params.bizInfo = {
            ...params.bizInfo,
            sgtPriceAdjustment: {
              enabled: false
            }
          };
        }
        const res = await fn(params);
        saveLoading.value = false;
        if (res.code === '0') {
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: 'ios商品配置',
              element_name: '保存'
            }
          });
          message.success('商品保存成功！');
          if (!saveNext.value) {
            router.push({
              name: 'goodsSetting'
            });
          } else {
            var _priceBlockRef$value14;
            // 连续创建时，初始化tab选择+清空三方渠道输入内容
            priceTabKey.value = '1';
            resetThirdParty();
            // 连续创建保留信息
            settingForm.value.productNativeInfo = params.productNativeInfo.map(item => {
              return {
                ...item,
                prodName: '',
                prodDescription: ''
              };
            });
            resetManualProdId();
            settingForm.value.prodId = settingForm.value.pkg;
            settingForm.value.prodPrice = '';
            settingForm.value.prodType = '';
            settingForm.value.remark = '';
            conturyPrice.value = [];
            defaultCountryId.value = '';
            settingForm.value.defaultPriceTier = '';
            (_priceBlockRef$value14 = priceBlockRef.value) === null || _priceBlockRef$value14 === void 0 || _priceBlockRef$value14.reset();
          }
        } else {}
      } catch (error) {}
    };
    // 判断是否有优惠方案
    const processProdGracePlan = prodGracePlanData => {
      if (prodGracePlanData) {
        return {
          regionConfigList: prodGracePlanData.regionConfigList.map(i => i.regionCode),
          type: prodGracePlanData.type,
          duration: prodGracePlanData.duration,
          productNativePrice: prodGracePlanData.productNativePrice,
          startDate: dayjs(prodGracePlanData.startDate),
          endDate: prodGracePlanData.endDate ? dayjs(prodGracePlanData.endDate) : ''
        };
      } else {
        return {
          regionConfigList: [],
          type: 'FREE_TRIAL',
          duration: 'THREE_DAYS',
          productNativePrice: [],
          startDate: '',
          endDate: ''
        };
      }
    };
    // ios 状态
    const iosStatus1 = ['MISSING_METADATA', 'READY_TO_SUBMIT', 'REJECTED', 'DEVELOPER_ACTION_NEEDED', 'DEVELOPER_REMOVED_FROM_SALE', 'REMOVED_FROM_SALE']; // 语言列表及价格可编辑
    const iosStatus2 = ['PENDING_BINARY_APPROVAL', 'WAITING_FOR_REVIEW', 'IN_REVIEW']; // 禁止编辑
    const iosStatus3 = ['APPROVED']; // 已存在的语言列表，仅可编辑商品名称+描述;不可删除已存在的语言列表;可新增语言;
    // const disabled1 = ref(false) // 语言列表及价格可编辑
    const disabled3 = ref(false); // 已存在的语言列表，仅可编辑商品名称+描述;不可删除已存在的语言列表;可新增语言;
    // 查询详情信息
    const getDetail = async () => {
      originLoading.value = true;
      const res = await queryGoods({
        id: queryParams.value.id
      });
      originLoading.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _data$prodBasePlan, _data$prodBasePlan2, _data$channelPrices, _data$bizInfo2;
        const {
          data
        } = res;
        originObj.value = cloneDeep(data);
        settingForm.value = {
          ...data,
          prodBasePlan: {
            // 订阅组
            id: (data === null || data === void 0 || (_data$prodBasePlan = data.prodBasePlan) === null || _data$prodBasePlan === void 0 ? void 0 : _data$prodBasePlan.id) || '',
            subscriptionType: '1',
            subscriptionPeriod: (data === null || data === void 0 || (_data$prodBasePlan2 = data.prodBasePlan) === null || _data$prodBasePlan2 === void 0 ? void 0 : _data$prodBasePlan2.subscriptionPeriod) || ''
          }
        };
        // 回显三方渠道：两套配置各自回填到自己的草稿，切换渠道即可看到各自保存的价格；
        // 总开关和当前渠道由 enableThirdPay 推导，都没开启时停在默认渠道
        const priceInfo = data === null || data === void 0 || (_data$channelPrices = data.channelPrices) === null || _data$channelPrices === void 0 ? void 0 : _data$channelPrices.priceInfo;
        const activeChannel = resolveThirdPartyChannel(priceInfo);
        thirdPartyEnabled.value = activeChannel.enabled;
        thirdPartyChannel.value = activeChannel.channel || DEFAULT_THIRD_PARTY_CHANNEL;
        thirdPartyDrafts.value = {
          xsolla_pay: normalizeThirdPartyDraft(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.xsolla_pay),
          enjoy_pay: normalizeThirdPartyDraft(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.enjoy_pay)
        };
        restoreTiered(data);
        // comingPricesList.value = data.bizInfo.upcomingPrices
        // 多默认价商品：regionCode/prodPrice 是 T1 基准国与价格、productNativePrice 是分层生成的本地价，
        // 不能回填到单一价格相关字段（否则切到单一会带出多默认价的值）。分层数据由 restoreTiered 回显。
        const isTiered = (data === null || data === void 0 || (_data$bizInfo2 = data.bizInfo) === null || _data$bizInfo2 === void 0 || (_data$bizInfo2 = _data$bizInfo2.tieredPricing) === null || _data$bizInfo2 === void 0 ? void 0 : _data$bizInfo2.pricingMode) === 'MULTI_DEFAULT_PRICE';
        // 判断是否展示即将修改的逻辑
        if (data && data.bizInfo && data.bizInfo.upcomingPrices) {
          isDeletedShow.value = data.bizInfo.upcomingPrices.isDeleted;
          isOriginHave.value = data.bizInfo.upcomingPrices.nextProductNativePrice ? true : false; // 记录原始值做是否删除了保存判断
        }
        // 编辑、查看时回显税率开关状态
        if (queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && showRateSwitch.value) {
          var _res$data$bizInfo$sgt, _res$data;
          taxRateSwitch.value = (_res$data$bizInfo$sgt = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.bizInfo) === null || _res$data === void 0 || (_res$data = _res$data.sgtPriceAdjustment) === null || _res$data === void 0 ? void 0 : _res$data.enabled) !== null && _res$data$bizInfo$sgt !== void 0 ? _res$data$bizInfo$sgt : false;
        }
        if (!isTiered) {
          var _priceBlockRef$value15;
          defaultCountryId.value = data.regionCode;
          settingForm.value.defaultPriceTier = data.prodPrice;
          await calcSelectOptions();
          await changeProdPrice(data.prodPrice, true);
          (_priceBlockRef$value15 = priceBlockRef.value) === null || _priceBlockRef$value15 === void 0 || _priceBlockRef$value15.init(data);
        } else {
          // 多默认价：单一价格保持「全新可配置」状态——默认国家美国 + 拉好价格档位下拉，
          // 但不回填具体价格/本地价（切到单一时不带出多默认价的值，又能直接配置）
          defaultCountryId.value = 'USA';
          await calcSelectOptions();
        }
        // 保存一份最初的价格合集，用来处理调整区域列表
        originPriceList.value = data.productNativePrice;
        // 判断 data.appleState 属于哪个 iosStatus1 iosStatus2 iosStatus3 iosStatus4
        if (iosStatus1.includes(data.appleState)) {
          // disabled1.value = false
          // disabled.value = true
        } else if (iosStatus2.includes(data.appleState)) {
          disabled.value = true;
        } else if (iosStatus3.includes(data.appleState)) {
          disabled3.value = true;
        } else {
          // disabled.value = false
          // disabled3.value = true
        }
        multiComponentRef.value && (multiComponentRef.value.originData = cloneDeep(settingForm.value.productNativeInfo));
        nextTick(() => {
          // 增加处理逻辑-根据状态处理价格设置列表数据
          cPriceList.value = [{
            title: '最初价格',
            money: `${data.prodPriceCurrency} ${data.prodPrice}`,
            area: `${data.productNativePrice.length}个国家或地区`,
            areaList: data.productNativePrice.map(item => {
              return {
                name: `${item.regionName} (${item.prodPriceCurrency})`,
                total: `${item.prodPriceCurrency} ${item.prodPrice}`
              };
            }),
            desc: ''
          }];
          if (settingForm.value.prodType == '32') {
            prodGracePlan.value = processProdGracePlan(data.prodGracePlan);
            yhShow.value = !!data.prodGracePlan;
          }
          // 如果有即将生效的价格列表，则处理展示值
          if (data.bizInfo.upcomingPrices) {
            const {
              regionCode,
              defaultPriceId,
              prodPriceCurrency,
              prodPrice,
              nextProductNativePrice
            } = data.bizInfo.upcomingPrices;
            // 用originPriceList去跟nextProductNativePrice比对，只要prodPrice值不相同就把这一项过滤出来
            const filterList = nextProductNativePrice.filter(item => {
              return originPriceList.value.some(ls => ls.regionName === item.regionName && Number(ls.prodPrice) !== Number(item.prodPrice));
            });
            let desc = '',
              useFlag = null;
            if (filterList && filterList.length && filterList[0].preserveCurrentPrice === true) {
              desc = '为现有订阅者保持当前价格';
              useFlag = true;
            } else if (data.preserveCurrentPrice === false) {
              desc = '将价格上调应用于现有订阅者';
              useFlag = false;
            }
            const list = {
              title: '审核通过后次日生效',
              money: `${prodPriceCurrency} ${prodPrice}`,
              area: `${nextProductNativePrice.length}个国家或地区`,
              areaList: nextProductNativePrice.map(item => {
                return {
                  name: `${item.regionName} (${item.prodPriceCurrency})`,
                  total: `${item.prodPriceCurrency} ${item.prodPrice}`
                };
              }),
              desc: desc
            };
            futurePriceList.value[0] = list;
            nextPriceData.value = cloneDeep({
              regionCode,
              prodPrice,
              prodPriceCurrency,
              defaultPriceId,
              nextProductNativePrice: filterList,
              preserveCurrentPrice: useFlag
            });
          }
        });
      }
    };
    const nextPriceData = ref();
    const savePriceData = data => {
      nextPriceData.value = cloneDeep(data);
      isDeletedShow.value = false;
      // 接受到弹框数据后将修改信息回显处理
      let desc = '';
      if (data.preserveCurrentPrice === true) {
        desc = '为现有订阅者保持当前价格';
      } else if (data.preserveCurrentPrice === false) {
        desc = '将价格上调应用于现有订阅者';
      }
      const list = {
        title: '审核通过后次日生效',
        money: `${nextPriceData.value.prodPriceCurrency} ${nextPriceData.value.prodPrice}`,
        area: `${nextPriceData.value.nextProductNativePrice.length}个国家或地区`,
        areaList: nextPriceData.value.nextProductNativePrice.map(item => {
          return {
            name: `${item.regionName} (${item.prodPriceCurrency})`,
            total: `${item.prodPriceCurrency} ${item.prodPrice}`
          };
        }),
        desc: desc
      };
      futurePriceList.value[0] = list;
    };
    const queryLastLangInfo = async () => {
      const [err, res] = await awaitWrap(getLastLangInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      }));
      if (err) return void 0;
      if (res && res.code === OK) {
        var _res$data2, _res$data3;
        if (((_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.lastLangInfos) === null || _res$data2 === void 0 ? void 0 : _res$data2.length) <= 1) return showLastLangInfo.value = false;
        showLastLangInfo.value = true;
        lastLangInfo.value = (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.lastLangInfos) === null || _res$data3 === void 0 ? void 0 : _res$data3.map(item => {
          return {
            ...item,
            prodDescription: '',
            prodName: ''
          };
        });
      }
    }; // 查询历史语言信息
    const changeLastLangInfo = () => {
      settingForm.value.productNativeInfo = lastLangInfo.value;
    }; // 修改历史语言信息
    const recordVisible = ref(false);
    const editRef = ref();
    const handleEdit = () => {
      var _editRef$value;
      (_editRef$value = editRef.value) === null || _editRef$value === void 0 || _editRef$value.openModal();
    };
    const deletePrice = () => {
      futurePriceList.value = [];
    };
    const showRateSwitch = computed(() => {
      return cCountry.value == 'SG' && queryParams.value.prodChnl == 'apple';
    }); // 渠道谷歌+默认币种是SGD则暂时税率开关
    const rateSwitchStatus = computed(() => {
      return queryParams.value.type === 'watch';
    }); // 详情时无法编辑税率开关
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      await getCountryCoinOptions();
      await Promise.all([getPkg(), getPicker()]);
      await queryLastLangInfo();
      if (queryParams.value.id) {
        getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_segmented = _resolveComponent("a-segmented");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: originLoading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
          ref_key: "myFormRef",
          ref: myFormRef,
          model: settingForm.value,
          "label-col": {
            style: 'width: 90px'
          },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = () => {
              _unref(router).back();
            })
          }, {
            default: _withCtx(() => [_createTextVNode(" 返回 ")]),
            _: 1
          }), _createElementVNode("div", {
            class: "record-text",
            onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
          }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
            label: "商品类型",
            name: "prodType",
            rules: [{
              required: true,
              type: 'string'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              class: "inputer",
              value: settingForm.value.prodType,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
              options: _unref(prodTypeOptions),
              onChange: changeProdType,
              disabled: Boolean(queryParams.value.id) || disabled.value
            }, {
              option: _withCtx(({
                label,
                describtion
              }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
              _: 1
            }, 8, ["value", "options", "disabled"])]),
            _: 1
          }), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: "订阅组",
            name: ['prodBasePlan', 'id'],
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              disabled: Boolean(queryParams.value.id) || disabled.value,
              style: {
                "width": "360px",
                "display": "inline-block"
              },
              value: settingForm.value.prodBasePlan.id,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.prodBasePlan.id = $event),
              options: dyList.value,
              "field-names": {
                label: 'groupName',
                value: 'subGroupId'
              }
            }, null, 8, ["disabled", "value", "options"]), !Boolean(queryParams.value.id) ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "ml8",
              type: "link",
              disabled: Boolean(queryParams.value.id) || disabled.value,
              onClick: clickDzAdd
            }, {
              default: _withCtx(() => [_createVNode(_unref(PlusOutlined)), _createTextVNode(" 新增订阅组 ")]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: "商品信息",
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(MultiComponents, {
              ref_key: "multiComponentRef",
              ref: multiComponentRef,
              filterItems: settingForm.value.productNativeInfo,
              onSetProdId: setProdId,
              disabled: disabled.value,
              disabled3: disabled3.value,
              onGetLastLange: changeLastLangInfo,
              showLastLangInfo: showLastLangInfo.value
            }, null, 8, ["filterItems", "disabled", "disabled3", "showLastLangInfo"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "prodId",
            rules: [{
              required: true,
              trigger: ['change', 'blur'],
              validator: _unref(validateIosPid)
            }]
          }, {
            label: _withCtx(() => [_hoisted_7, _createVNode(_component_a_tooltip, {
              placement: "right"
            }, {
              title: _withCtx(() => [_hoisted_8]),
              default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
                class: "infoIcon ml4"
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(_component_a_input, {
              class: "inputer",
              value: settingForm.value.prodId,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.prodId = $event),
              placeholder: "请输入内购ID",
              disabled: Boolean(queryParams.value.id) || disabled.value,
              maxlength: 100,
              onFocus: _unref(handleProdIdFocus),
              onBlur: _unref(handleProdIdBlur)
            }, null, 8, ["value", "disabled", "onFocus", "onBlur"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              class: "bigInputer",
              value: settingForm.value.remark,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.remark = $event),
              maxlength: 20,
              placeholder: "请输入",
              disabled: disabled.value
            }, null, 8, ["value", "disabled"])]),
            _: 1
          }), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            label: "订阅时长",
            name: ['prodBasePlan', 'subscriptionPeriod'],
            rules: [{
              required: true,
              type: 'string'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              disabled: Boolean(queryParams.value.id) || disabled.value,
              style: {
                "width": "360px"
              },
              value: settingForm.value.prodBasePlan.subscriptionPeriod,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.prodBasePlan.subscriptionPeriod = $event),
              options: timeStep
            }, null, 8, ["disabled", "value"])]),
            _: 1
          })) : _createCommentVNode("", true), settingForm.value.prodType == '10' ? (_openBlock(), _createElementBlock("div", _hoisted_9, " *非消耗型商品，商品名称与商品描述请突出明显区别，否则发布将无法申请推广你的APP内购买项目 ")) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_a_spin, {
            spinning: conturyPriceLoading.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" 价格设置 "), _unref(showThirdPartyTab) ? (_openBlock(), _createBlock(_component_a_segmented, {
              key: 0,
              value: priceTabKey.value,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => priceTabKey.value = $event),
              options: priceTabOptions,
              class: "price-segmented"
            }, {
              label: _withCtx(({
                value,
                title
              }) => [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", {
                class: _normalizeClass(["price-tab-dot", {
                  off: value === '2' && !thirdPartyEnabled.value
                }])
              }, null, 2), _createTextVNode(" " + _toDisplayString(title), 1)])]),
              _: 1
            }, 8, ["value"])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", null, [_unref(showTieredOption) ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "定价模式"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                value: priceMode.value,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => priceMode.value = $event),
                disabled: disabled.value,
                onChange: onPriceModeChange
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio, {
                  value: "single"
                }, {
                  default: _withCtx(() => [_createTextVNode("单一默认价格")]),
                  _: 1
                }), _createVNode(_component_a_radio, {
                  value: "tiered"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 多默认价格 "), _createVNode(_component_a_tag, {
                    class: "tiered-tag ml4"
                  }, {
                    default: _withCtx(() => [_createTextVNode("按国家分层定价")]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["value", "disabled"])]),
              _: 1
            })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_a_form_item, {
              label: "默认价格",
              name: "defaultPriceTier",
              rules: [{
                required: priceMode.value === 'single'
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                disabled: disabled.value,
                getPopupContainer: _unref(getNode),
                class: "selecter",
                value: defaultCountryId.value,
                "onUpdate:value": _cache[9] || (_cache[9] = $event => defaultCountryId.value = $event),
                placholder: "请选择语言",
                "filter-option": filterOption,
                style: {
                  "width": "140px",
                  "margin-right": "12px"
                },
                onChange: calcSelectOptions,
                "show-search": "",
                options: defaultCountry.value,
                "field-names": {
                  label: 'regionName',
                  value: 'regionCode'
                }
              }, null, 8, ["disabled", "getPopupContainer", "value", "options"]), _createVNode(_component_a_select, {
                disabled: disabled.value,
                class: "selecter",
                "show-search": "",
                value: settingForm.value.defaultPriceTier,
                "onUpdate:value": _cache[10] || (_cache[10] = $event => settingForm.value.defaultPriceTier = $event),
                style: {
                  "width": "140px",
                  "display": "inline-block"
                },
                placholder: "请选择价格",
                onChange: changeProdPrice,
                loading: conturyPriceLoading.value,
                "field-names": {
                  label: 'prodPrice',
                  value: 'prodPrice'
                },
                options: conturyPrice.value
              }, null, 8, ["disabled", "value", "loading", "options"])]),
              _: 1
            }, 8, ["rules"]), _createVNode(_component_a_form_item, {
              label: "本地价格",
              rules: [{
                required: true
              }]
            }, {
              default: _withCtx(() => [_createVNode(PriceBlock2, {
                "prod-type": settingForm.value.prodType,
                dbtId: queryParams.value.dbtId,
                "prod-chnl": queryParams.value.prodChnl,
                "prod-price-currency": settingForm.value.prodPriceCurrency,
                disabled: disabled.value,
                originPriceList: originPriceList.value,
                taxRateSwitch: taxRateSwitch.value,
                ref_key: "priceBlockRef",
                ref: priceBlockRef,
                onUpdateList: handlePriceTierChange
              }, null, 8, ["prod-type", "dbtId", "prod-chnl", "prod-price-currency", "disabled", "originPriceList", "taxRateSwitch"])]),
              _: 1
            })], 512), [[_vShow, !_unref(showTieredOption) || priceMode.value === 'single']]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_a_form_item, {
              label: "层级默认价",
              rules: [{
                required: true
              }]
            }, {
              default: _withCtx(() => [_createVNode(TierDefaultPrice, {
                ref_key: "tierDefaultRef",
                ref: tierDefaultRef,
                "prod-chnl": queryParams.value.prodChnl,
                "prod-type": settingForm.value.prodType,
                "dbt-id": queryParams.value.dbtId,
                "country-options": defaultCountry.value,
                "prod-price-currency": settingForm.value.prodPriceCurrency,
                disabled: disabled.value,
                onChange: onTierDefaultPriceChange
              }, null, 8, ["prod-chnl", "prod-type", "dbt-id", "country-options", "prod-price-currency", "disabled"])]),
              _: 1
            }), _createVNode(_component_a_form_item, {
              label: "本地价格",
              rules: [{
                required: true
              }]
            }, {
              default: _withCtx(() => [_createVNode(TierLocalPriceTable, {
                ref_key: "tierLocalRef",
                ref: tierLocalRef,
                pkg: settingForm.value.pkg,
                "prod-chnl": queryParams.value.prodChnl,
                "prod-type": settingForm.value.prodType,
                "prod-price-currency": settingForm.value.prodPriceCurrency,
                "dbt-id": queryParams.value.dbtId,
                "tier-levels": _unref(tierLevels),
                "pin-singapore": _unref(showRateSwitch) && taxRateSwitch.value,
                disabled: disabled.value,
                onChange: regenerateTiered
              }, null, 8, ["pkg", "prod-chnl", "prod-type", "prod-price-currency", "dbt-id", "tier-levels", "pin-singapore", "disabled"])]),
              _: 1
            })], 512), [[_vShow, _unref(showTieredOption) && priceMode.value === 'tiered']]), priceMode.value === 'single' && _unref(showRateSwitch) || priceMode.value === 'tiered' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 1,
              label: "GST调价",
              class: "gst-form-item"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_switch, {
                checked: taxRateSwitch.value,
                "onUpdate:checked": _cache[11] || (_cache[11] = $event => taxRateSwitch.value = $event),
                disabled: _unref(rateSwitchStatus) || conturyPriceLoading.value,
                onChange: onGstChange
              }, null, 8, ["checked", "disabled"]), _createElementVNode("div", {
                class: _normalizeClass(["taxRateText", {
                  disabled: _unref(rateSwitchStatus) || conturyPriceLoading.value
                }]),
                onClick: onGstClick
              }, _hoisted_17, 2)])]),
              _: 1
            })) : _createCommentVNode("", true), priceMode.value === 'tiered' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 2,
              label: "层级模板"
            }, {
              default: _withCtx(() => [_createVNode(TierTemplateSwitch, {
                modelValue: tierTemplateEnabled.value,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => tierTemplateEnabled.value = $event),
                disabled: disabled.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })) : _createCommentVNode("", true)], 512), [[_vShow, priceTabKey.value === '1']]), _withDirectives(_createVNode(_component_a_form, {
              model: _unref(thirdPartyConfig),
              "label-col": {
                style: 'width: 98px'
              },
              class: "third-party-pay-form"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "开启三方支付"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_switch, {
                  checked: thirdPartyEnabled.value,
                  "onUpdate:checked": _cache[13] || (_cache[13] = $event => thirdPartyEnabled.value = $event),
                  disabled: disabled.value
                }, null, 8, ["checked", "disabled"]), _hoisted_19])]),
                _: 1
              }), thirdPartyEnabled.value ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createVNode(_component_a_form_item, {
                label: "开启渠道",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                  value: thirdPartyChannel.value,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => thirdPartyChannel.value = $event),
                  disabled: disabled.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(THIRD_PARTY_CHANNEL_OPTIONS), item => {
                    return _openBlock(), _createBlock(_component_a_radio, {
                      key: item.value,
                      value: item.value,
                      disabled: !isChannelAvailable(item.value)
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1032, ["value", "disabled"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value", "disabled"])]),
                _: 1
              }), _createVNode(ThirdPartyPricePanel, {
                ref_key: "thirdPartyPanelRef",
                ref: thirdPartyPanelRef,
                modelValue: _unref(thirdPartyConfig),
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _isRef(thirdPartyConfig) ? thirdPartyConfig.value = $event : null),
                "official-price": _unref(thirdPartyOfficialPrice),
                "missing-official-tip": _unref(thirdPartyOfficialTip),
                "channel-name": _unref(thirdPartyChannelName),
                "price-tip": _unref(thirdPartyPriceTip),
                disabled: disabled.value
              }, null, 8, ["modelValue", "official-price", "missing-official-tip", "channel-name", "price-tip", "disabled"])], 64)) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["model"]), [[_vShow, priceTabKey.value === '2' && _unref(showThirdPartyTab)]])])]),
            _: 1
          }, 8, ["spinning"]), [[_vShow, priceTabKey.value === '1' && (settingForm.value.prodType != '32' || settingForm.value.appleState != 'APPROVED') || priceTabKey.value === '2' && _unref(showThirdPartyTab)]]), priceTabKey.value === '1' && settingForm.value.prodType == '32' && queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createBlock(_component_a_spin, {
            key: 0,
            spinning: priceTrend.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createTextVNode(" 价格设置 "), settingForm.value.prodType == '32' && queryParams.value.type && ['edit'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "edit-price",
              onClick: handleEdit
            }, " 修改订阅价格 ")) : _createCommentVNode("", true)]), settingForm.value.prodType == '32' && queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 商品当前状态：" + _toDisplayString(_unref(statusText)), 1)) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_24, [futurePriceList.value.length > 0 && !isDeletedShow.value ? (_openBlock(), _createElementBlock("li", _hoisted_25, "即将生效价格")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(futurePriceList.value, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                class: "l-item",
                key: index,
                style: {
                  "margin-bottom": "12px"
                }
              }, [_createElementVNode("span", _hoisted_26, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(item.money), 1), _createElementVNode("div", _hoisted_28, [_createVNode(_component_a_popover, {
                overlayClassName: "popover-ios",
                placement: "right"
              }, {
                content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.areaList, (ls, index) => {
                  return _openBlock(), _createElementBlock("p", {
                    class: "popover-item",
                    key: index
                  }, [_createElementVNode("span", null, _toDisplayString(ls.name), 1), _createElementVNode("span", null, _toDisplayString(ls.total), 1)]);
                }), 128))]),
                title: _withCtx(() => [_hoisted_29]),
                default: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(item.area) + " ", 1), _unref(showRateSwitch) && taxRateSwitch.value ? (_openBlock(), _createElementBlock("span", _hoisted_30, "(GST调价已开启)")) : _createCommentVNode("", true)])]),
                _: 2
              }, 1024)]), item.desc ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.desc), 1)) : _createCommentVNode("", true), queryParams.value.type == 'edit' ? (_openBlock(), _createBlock(_unref(RestOutlined), {
                key: 1,
                class: "btn-icon",
                onClick: deletePrice
              })) : _createCommentVNode("", true)])), [[_vShow, !isDeletedShow.value]]);
            }), 128)), _hoisted_32, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cPriceList.value, (item, index) => {
              return _openBlock(), _createElementBlock("li", {
                class: "l-item",
                key: index
              }, [_createElementVNode("span", _hoisted_33, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(item.money), 1), _createElementVNode("div", _hoisted_35, [_createVNode(_component_a_popover, {
                overlayClassName: "popover-ios",
                placement: "right"
              }, {
                content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.areaList, (ls, index) => {
                  return _openBlock(), _createElementBlock("p", {
                    class: "popover-item",
                    key: index
                  }, [_createElementVNode("span", null, _toDisplayString(ls.name), 1), _createElementVNode("span", null, _toDisplayString(ls.total), 1)]);
                }), 128))]),
                title: _withCtx(() => [_hoisted_36]),
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.area), 1)]),
                _: 2
              }, 1024)]), item.desc ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.desc), 1)) : _createCommentVNode("", true)]);
            }), 128))])])]),
            _: 1
          }, 8, ["spinning"])) : _createCommentVNode("", true), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_spin, {
            key: 1,
            spinning: spinning.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createTextVNode(" 优惠方案 "), _createElementVNode("div", _hoisted_41, [yhShow.value ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              disabled: disabled.value,
              onClick: _cache[16] || (_cache[16] = $event => yhShowChange(false)),
              type: "link"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DeleteOutlined)), _createTextVNode(" 删除优惠 ")]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)])]), !yhShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_svg_icon, {
              iconClass: "ticket",
              style: {
                "width": "78px",
                "height": "78px",
                "margin-top": "48px",
                "margin-bottom": "16px"
              }
            }), _hoisted_43, _createVNode(_component_a_button, {
              type: "link",
              style: {
                "margin-bottom": "24px"
              },
              disabled: disabled.value,
              onClick: _cache[17] || (_cache[17] = $event => yhShowChange(true))
            }, {
              default: _withCtx(() => [_createTextVNode(" 添加 ")]),
              _: 1
            }, 8, ["disabled"])])) : _createCommentVNode("", true), yhShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_a_form, {
              model: prodGracePlan.value,
              "label-col": {
                style: 'width: 80px'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "适用范围",
                name: "regionConfigList",
                required: ""
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: {
                    "cursor": "pointer",
                    "color": "rgba(38, 72, 255, 1)"
                  },
                  class: "choose-country",
                  onClick: showCountryModal
                }, " 选择参与优惠的国家/地区 ")]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "生效时长",
                required: "",
                name: "startDate"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                  disabled: disabled.value,
                  value: prodGracePlan.value.startDate,
                  "onUpdate:value": _cache[18] || (_cache[18] = $event => prodGracePlan.value.startDate = $event),
                  "disabled-date": disabledDate,
                  onChange: _cache[19] || (_cache[19] = () => {
                    prodGracePlan.value.endDate = '';
                  }),
                  placeholder: "请选择开始日期"
                }, null, 8, ["disabled", "value"]), _createTextVNode(" ~ "), _createVNode(_component_a_date_picker, {
                  allowClear: "",
                  "disabled-date": disabledDate1,
                  disabled: disabled.value,
                  value: prodGracePlan.value.endDate,
                  "onUpdate:value": _cache[21] || (_cache[21] = $event => prodGracePlan.value.endDate = $event),
                  placeholder: dataText.value,
                  ref_key: "endDate",
                  ref: endDate,
                  open: endDateOpen.value,
                  onFocus: _cache[22] || (_cache[22] = () => {
                    endDateOpen.value = true;
                  }),
                  onBlur: _cache[23] || (_cache[23] = () => {
                    endDateOpen.value = false;
                  })
                }, {
                  renderExtraFooter: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_a_button, {
                    type: "text",
                    onClick: _cache[20] || (_cache[20] = () => {
                      ;
                      endDateOpen.value = false, dataText.value = '无结束日期';
                    })
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 无结束日期 ")]),
                    _: 1
                  })])]),
                  _: 1
                }, 8, ["disabled", "value", "placeholder", "open"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "优惠类型",
                required: "",
                name: "type"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Select), {
                  disabled: disabled.value,
                  value: prodGracePlan.value.type,
                  "onUpdate:value": _cache[24] || (_cache[24] = $event => prodGracePlan.value.type = $event),
                  style: {
                    "width": "340px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(SelectOption), {
                    value: "FREE_TRIAL"
                  }, {
                    default: _withCtx(() => [_createTextVNode("免费试订，订阅者在指定期限内无需付费")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["disabled", "value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "优惠时长",
                required: "",
                name: "duration"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Select), {
                  disabled: disabled.value,
                  value: prodGracePlan.value.duration,
                  "onUpdate:value": _cache[25] || (_cache[25] = $event => prodGracePlan.value.duration = $event),
                  style: {
                    "width": "340px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(SelectOption), {
                    value: "THREE_DAYS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("三天")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_WEEK"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一周")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "TWO_WEEKS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("两周")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_MONTH"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "TWO_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("两个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "THREE_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("三个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "SIX_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("六个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_YEAR"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一年")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["disabled", "value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "本地价格"
              }, {
                default: _withCtx(() => [_createVNode(PriceBlock1, {
                  "prod-chnl": queryParams.value.prodChnl,
                  "prod-price-currency": settingForm.value.prodPriceCurrency,
                  disabled: disabled.value,
                  ref: "priceBlockRef1",
                  yhConturyPrice: _unref(yhConturyPrice),
                  "onUpdate:yhConturyPrice": _cache[26] || (_cache[26] = $event => _isRef(yhConturyPrice) ? yhConturyPrice.value = $event : null),
                  onUpdateList: changeProdPrice
                }, null, 8, ["prod-chnl", "prod-price-currency", "disabled", "yhConturyPrice"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"])])) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["spinning"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"]), _withDirectives(_createElementVNode("div", {
          class: "submitBlock",
          style: _normalizeStyle(_unref(submitBlockStyle))
        }, [_createVNode(_component_a_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          loading: saveLoading.value,
          class: "ml8",
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_createTextVNode("保 存")]),
          _: 1
        }, 8, ["loading"]), _withDirectives(_createElementVNode("div", _hoisted_46, [_createVNode(_component_a_checkbox, {
          checked: saveNext.value,
          "onUpdate:checked": _cache[27] || (_cache[27] = $event => saveNext.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("连续创建")]),
          _: 1
        }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 4), [[_vShow, !disabled.value]]), _createVNode(SelectModal, {
          "read-only": disabled.value,
          "model-visible": visible.value,
          "onUpdate:model-visible": _cache[28] || (_cache[28] = $event => visible.value = $event),
          title: "选择国家/地区",
          "all-list": _unref(allData),
          onSaveData: saveCountry,
          "edit-item": _unref(yhContury)
        }, null, 8, ["read-only", "model-visible", "all-list", "edit-item"]), _createVNode(DyzModal, {
          ref_key: "dzmodal",
          ref: dzmodal,
          modalVisible: modalVisible.value,
          "onUpdate:modalVisible": _cache[29] || (_cache[29] = $event => modalVisible.value = $event),
          dbtId: queryParams.value.dbtId,
          prodChnl: queryParams.value.prodChnl,
          onUpdateList: refreshDy
        }, null, 8, ["modalVisible", "dbtId", "prodChnl"]), _createVNode(EditModal, {
          ref_key: "editRef",
          ref: editRef,
          goodsInfo: settingForm.value,
          showRateSwitch: _unref(showRateSwitch),
          taxRateSwitch: taxRateSwitch.value,
          areaList: _unref(allAreaList),
          originPriceList: originPriceList.value,
          onSendNextPriceData: savePriceData
        }, null, 8, ["goodsInfo", "showRateSwitch", "taxRateSwitch", "areaList", "originPriceList"]), _createVNode(RecordDrawer, {
          visible: recordVisible.value,
          "onUpdate:visible": _cache[30] || (_cache[30] = $event => recordVisible.value = $event)
        }, null, 8, ["visible"]), _createVNode(UnusedTierConfirmModal, {
          open: unusedModalOpen.value,
          "onUpdate:open": _cache[31] || (_cache[31] = $event => unusedModalOpen.value = $event),
          "unused-tiers": unusedTiers.value,
          loading: tieredSaving.value,
          onConfirm: onUnusedConfirm,
          onCancel: onUnusedCancel
        }, null, 8, ["open", "unused-tiers", "loading"]), _createVNode(PriceModeConfirmModal, {
          open: priceModeConfirmOpen.value,
          "onUpdate:open": _cache[32] || (_cache[32] = $event => priceModeConfirmOpen.value = $event),
          mode: priceMode.value,
          loading: saveLoading.value,
          onConfirm: onPriceModeConfirm,
          onCancel: onPriceModeConfirmCancel
        }, null, 8, ["open", "mode", "loading"])])]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
});